import { useState, useEffect } from 'react';

/**
 * Custom hook to extract and manage URL search parameters
 * @returns Object containing URL parameters
 */
export const useUrlParams = () => {
  const [params, setParams] = useState<URLSearchParams>(new URLSearchParams());

  useEffect(() => {
    // Get current URL search parameters
    const urlParams = new URLSearchParams(window.location.search);
    setParams(urlParams);

    // Listen for URL changes (if using client-side routing)
    const handleLocationChange = () => {
      const newParams = new URLSearchParams(window.location.search);
      setParams(newParams);
    };

    window.addEventListener('popstate', handleLocationChange);

    return () => {
      window.removeEventListener('popstate', handleLocationChange);
    };
  }, []);

  return params;
};
